import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const featuredProducts = [
    {
      id: 1,
      name: 'Chaleco Táctico Modular',
      category: 'EQUIPAMIENTO TÁCTICO',
      image:
        'https://public.readdy.ai/ai/img_res/fa150597462691eb379c951085b835e6.jpg',
    },
    {
      id: 2,
      name: 'Botas Militares Profesionales',
      category: 'CALZADO TÁCTICO',
      image:
        'https://readdy.ai/api/search-image?query=professional-military-tactical-boots-black-combat-footwear-high-quality-durable-on-clean-simple-neutral-gray-background-product-photography-detailed-side-view-military-equipment&width=600&height=600&seq=prod2&orientation=squarish',
    },
    {
      id: 3,
      name: 'Linterna Táctica LED',
      category: 'ILUMINACIÓN',
      image:
        'https://readdy.ai/api/search-image?query=professional-tactical-led-flashlight-military-grade-aluminum-body-high-power-on-clean-simple-neutral-gray-background-product-photography-detailed-view-tactical-equipment&width=600&height=600&seq=prod3&orientation=squarish',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/2c80217b5d6e991d333cfe813d9460a6.png"
            alt="Artaca Tactic Panama Tienda"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
        </div>

        <div className="relative z-10 text-center px-4 sm:px-6 w-full max-w-5xl mx-auto pt-20 sm:pt-24">
          <div className="inline-block mb-4 sm:mb-6 px-4 sm:px-6 py-2 border-2 border-[#7cb342] rounded-full">
            <span className="text-white text-xs sm:text-sm font-semibold tracking-wider">
              EQUIPAMIENTO PROFESIONAL DESDE 2020
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-3 sm:mb-4">
            <span className="text-white block">EQUIPOS TÁCTICOS</span>
            <span className="text-[#7cb342] block">Y MILITARES DE ÉLITE</span>
          </h1>

          <p className="text-white/85 text-base sm:text-lg lg:text-xl mb-8 sm:mb-10 max-w-3xl mx-auto font-light px-2">
            La tienda líder en Panamá para fuerzas de seguridad y profesionales
          </p>

          <div className="inline-flex items-center space-x-2 bg-[#7cb342]/20 border border-[#7cb342]/50 rounded-full px-5 py-2.5 mb-8 sm:mb-10">
            <i className="ri-truck-line text-[#7cb342] text-lg sm:text-xl w-5 h-5 flex items-center justify-center"></i>
            <span className="text-white text-sm sm:text-base font-semibold tracking-wide">Se realiza delivery hasta el interior</span>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4 sm:px-0">
            <Link
              to="/productos"
              className="w-full sm:w-auto inline-flex items-center justify-center space-x-2 bg-[#1a3a2e] hover:bg-[#2d5016] text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg transition-all font-semibold text-base sm:text-lg whitespace-nowrap cursor-pointer"
            >
              <span>VER CATÁLOGO</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/contacto"
              className="w-full sm:w-auto inline-flex items-center justify-center space-x-2 border-2 border-white hover:bg-white hover:text-black text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg transition-all font-semibold text-base sm:text-lg whitespace-nowrap cursor-pointer"
            >
              <span>CONTACTAR AHORA</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="bg-[#f8f8f6] py-14 sm:py-20 lg:py-32">
        <div className="w-full px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 mb-10 sm:mb-16">
            <div>
              <h2 className="text-gray-600 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light mb-1 sm:mb-2">
                Nuestra Garantía
              </h2>
              <h3 className="text-black text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold">
                CALIDAD PROFESIONAL
              </h3>
            </div>
            <div className="flex items-center">
              <p className="text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed">
                En Artaca Tactic Panama nos comprometemos a ofrecer únicamente productos
                certificados y de la más alta calidad. Cada artículo es seleccionado
                cuidadosamente para garantizar el máximo rendimiento y durabilidad que los
                profesionales necesitan.
              </p>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#1a3a2e] rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-shield-check-line text-2xl sm:text-3xl text-[#7cb342]"></i>
              </div>
              <h4 className="text-black text-lg sm:text-xl lg:text-2xl font-semibold mb-3 sm:mb-4">
                PRODUCTOS CERTIFICADOS
              </h4>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                Equipamiento militar y táctico con certificaciones internacionales de calidad y
                seguridad.
              </p>
            </div>

            <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#1a3a2e] rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-star-line text-2xl sm:text-3xl text-[#7cb342]"></i>
              </div>
              <h4 className="text-black text-lg sm:text-xl lg:text-2xl font-semibold mb-3 sm:mb-4">
                ATENCIÓN ESPECIALIZADA
              </h4>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                Personal capacitado para asesorarte en la selección del equipo ideal según tus
                necesidades.
              </p>
            </div>

            <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-lg hover:shadow-xl transition-shadow sm:col-span-2 md:col-span-1">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#1a3a2e] rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-map-pin-line text-2xl sm:text-3xl text-[#7cb342]"></i>
              </div>
              <h4 className="text-black text-lg sm:text-xl lg:text-2xl font-semibold mb-3 sm:mb-4">
                FÁCIL ACCESO EN MEGAMALL
              </h4>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                Ubicación estratégica en Megamall Panamá, fácil de encontrar y con amplio horario
                de atención.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products Section */}
      <section className="bg-black py-14 sm:py-20 lg:py-28">
        <div className="w-full px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-16">
            <div className="inline-block mb-3 sm:mb-4 px-4 sm:px-6 py-2 border border-[#7cb342] rounded-full">
              <span className="text-[#7cb342] text-xs font-semibold tracking-widest">
                (EQUIPAMIENTO PROFESIONAL)
              </span>
            </div>
            <h2 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold tracking-wide">
              NUESTROS<br />PRODUCTOS
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8" data-product-shop>
            {featuredProducts.map((product) => (
              <div
                key={product.id}
                className="bg-[#1a1a1a] rounded-xl sm:rounded-2xl overflow-hidden group hover:scale-[1.03] transition-all duration-300"
              >
                <div className="relative h-56 sm:h-64 md:h-72 lg:h-80 w-full overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 sm:p-6">
                  <span className="text-[#7cb342] text-xs font-semibold tracking-wider">
                    {product.category}
                  </span>
                  <h3 className="text-white text-lg sm:text-xl lg:text-2xl font-semibold mt-2 leading-tight">
                    {product.name}
                  </h3>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8 sm:mt-12">
            <Link
              to="/productos"
              className="inline-flex items-center space-x-2 border-2 border-[#7cb342] hover:bg-[#7cb342] text-[#7cb342] hover:text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-lg transition-all font-semibold text-base sm:text-lg whitespace-nowrap cursor-pointer"
            >
              <span>VER TODOS LOS PRODUCTOS</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#1a3a2e] py-14 sm:py-20 lg:py-28">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold mb-4 sm:mb-6">
            ¿Listo para equiparte con lo mejor?
          </h2>
          <p className="text-white/80 text-sm sm:text-base lg:text-xl mb-8 sm:mb-10 max-w-2xl mx-auto">
            Visítanos en Megamall Panamá o contáctanos por WhatsApp para recibir asesoría
            personalizada
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4 sm:px-0">
            <a
              href="https://wa.me/50765358000"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto inline-flex items-center justify-center space-x-2 bg-[#7cb342] hover:bg-[#689f38] text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-full transition-all font-semibold text-base sm:text-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl sm:text-2xl w-6 h-6 flex items-center justify-center"></i>
              <span>CHATEAR EN WHATSAPP</span>
            </a>
            <Link
              to="/ubicacion"
              className="w-full sm:w-auto inline-flex items-center justify-center space-x-2 border-2 border-white hover:bg-white hover:text-[#1a3a2e] text-white px-6 sm:px-8 py-3.5 sm:py-4 rounded-full transition-all font-semibold text-base sm:text-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-map-pin-line text-lg sm:text-xl w-5 h-5 flex items-center justify-center"></i>
              <span>VER UBICACIÓN</span>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
